import React from 'react';

const BackButton = () => (
  <button onClick={() => window.history.back()} className="BackButton" aria-label="Zurück">
    <i className="fa fa-chevron-left" aria-hidden="true" />
  </button>
);

export default BackButton;



// WEBPACK FOOTER //
// ./src/js/components/BackButton.js